import { Route } from "react-router-dom";
import {
  HomeScreen,
  CartScreen,
  CheckoutScreen,
  PaymentCallbackScreen,
  ContactScreen,
  OurMenuScreen,
  ServicesScreen,
  TrackOrderScreen,
  OrderTrackingScreen,
  FAQScreen,
  TestimonialsScreen,
  PrivacyPolicyScreen,
  TermsOfServiceScreen,
  RefundPolicyScreen,
  DealsScreen,
  DealDetailsScreen,
} from "../screens";

export const publicRoutes = [
  <Route key="home" path="/" element={<HomeScreen />} />,
  // <Route key="shop" path="/shop" element={<ShopScreen />} />,
  <Route key="deals" path="/deals" element={<DealsScreen />} />,
  <Route
    key="deal-details"
    path="/deals/:id"
    element={<DealDetailsScreen />}
  />,
  <Route key="our-menu" path="/our-menu" element={<OurMenuScreen />} />,
  // <Route key="product" path="/product/:id" element={<ProductDetailsScreen />} />,
  <Route key="cart" path="/cart" element={<CartScreen />} />,
  <Route key="checkout" path="/checkout" element={<CheckoutScreen />} />,
  <Route
    key="payment-callback"
    path="/payment/callback"
    element={<PaymentCallbackScreen />}
  />,
  <Route key="contact" path="/contact" element={<ContactScreen />} />,
  <Route key="services" path="/services" element={<ServicesScreen />} />,
  <Route key="faq" path="/faq" element={<FAQScreen />} />,
  <Route
    key="testimonials"
    path="/testimonials"
    element={<TestimonialsScreen />}
  />,
  <Route
    key="privacy-policy"
    path="/privacy-policy"
    element={<PrivacyPolicyScreen />}
  />,
  <Route
    key="terms-of-service"
    path="/terms-of-service"
    element={<TermsOfServiceScreen />}
  />,
  <Route
    key="refund-policy"
    path="/refund-policy"
    element={<RefundPolicyScreen />}
  />,
  <Route
    key="track-order"
    path="/track-order"
    element={<TrackOrderScreen />}
  />,
  <Route
    key="order-tracking"
    path="/orders/:token"
    element={<OrderTrackingScreen />}
  />,
];
